<template>
    <b-card :class="widgetClass">
        <div class="text-center text-primary my-2" v-if="!models">
            <b-spinner class="align-middle"></b-spinner>
        </div>

        <div v-else>
        <div v-if="widget.icon.value" :class="`h1 text-${widget.icon.type} mb-4`">
            <i :class="widget.icon.value"></i>
        </div>
        <div class="h4 m-0">{{ value }}</div>
        <div>{{ widget.title }}</div>

        <b-progress height={} class="progress-xs my-3" :variant="widget.progressBar.variant" :value="progressValue" v-if="widget.progressBar.bar"/>

        <small class="text-muted">{{ widget.description }}</small>
        </div>
    </b-card>
</template>

<script>
import safeEval from 'safe-eval'
import _ from 'lodash'

export default {
    props: {
        widget: {
            type: Object
        }
    },
    data: function() {
        return {
            models: null
        }
    },
    computed: {
        widgetClass() {
            if (this.widget.variant != "" && this.widget.variant != "light") {
                 return "text-white " + "bg-" + this.widget.variant
            }
        },
        
        value() {
            let result = safeEval('(function() { try { ' + this.widget.formatter.code + ' } catch (err) { return err.message  } })()', {
                models: this.models,
                _: _
            })
                
            return result
        },

        progressValue() {
            let result = safeEval('(function() { try { ' + this.widget.progressBar.formatter + ' } catch (err) { return err.message  } })()', {
                models: this.models,
                _: _
            })

            return result
        }
    },

    created() {
        let payload = {
            uuid: this.widget.component,
            context: {
                limit: this.widget.formatter.limit,
                filter: this.widget.formatter.filter,
                filterOn: this.widget.formatter.filterOn,
                disabled: this.widget.formatter.disabled
            }
        }

        this.$store.dispatch('fetchComponentsModels', payload).then(data => {
            this.models = data.items
        }).catch(err => {
            // skip it
            this.models = []
        }) 
    }
}
</script>